export default __webpack_public_path__ + "static/media/sponsor-corinthians.8ac2b679.png";